//shiftsService.js
import api from "./api";

export const shiftsPost = async (data) => {
  return await api.post("/api/shifts", data);
};

export const shiftsGets = async () => {
  return await api.get("/api/shifts");
};

export const shiftDeleteById = async (id) => {
  return await api.delete(`/api/shifts/${id}`);
};

//http://localhost:8080/api/employee-shifts/district/2

export const shiftListAssign = async (districtId, designation) => {
  if (designation) {
    return await api.get(`/api/employee-shifts/district/${districtId}?designationId=${designation}`);
  }
  return await api.get(`/api/employee-shifts/district/${districtId}`);
};


export const shiftsAssignmentSubmit= async(payload)=>{
  const response= await api.post(`/api/employee-shifts/assign/individual`,payload);
  return response;
}

export const getDesignationsByRoleId = async (roleId) => {
    const response= await api.get(`/api/roles/${roleId}/designations`);
    return response.data;
};


export const getDesignationsForEmployees = async () => {
    const response= await api.get(`/api/designations/dropdown`);
    return response.data;
};